import React, { FC } from "react";

import TemplateEdit from "../../components/Template/TemplateEdit";

const TemplateEditPage: FC = () => <TemplateEdit />;

export default TemplateEditPage;
